import moment from 'moment-timezone'

export const getAge = (birthday: string) => {
  if (birthday.length === 10) {
    return moment().diff(moment(birthday, 'DD/MM/YYYY'), 'years')
  } else return ''
}
